import { Card, Col } from 'react-bootstrap';


const RegionCard = ({ region_name, region_slug, flag_image, isLoading, onClick }) => (
    <Col xs={12} sm={12} md={6} lg={6} className="mb-4 mt-2"  >
        {isLoading ? (
            <p>Loading...</p>
        ) : (
            <Card className="country-listing-box" onClick={() => onClick(region_slug)} style={{ cursor: 'pointer' }}  >
                <Card.Body className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center" >
                        <img
                            src={flag_image}
                            alt={`${region_name} flag`}
                            className="me-2"
                            style={{ height: '35px', width: 'auto', paddingRight: '5px' }}
                        />
                        <span>{region_name}</span>
                    </div>
                    <i className="bi bi-caret-down-fill text-muted"></i>
                </Card.Body>
            </Card>
        )}
    </Col>
);

export default RegionCard;

